'use client';

import { FormControl, FormLabel, TextField } from '@mui/material';

import { InputErrorIcon } from '@/components/form/validation/inputErrorIcon';

import { inputSx } from './fieldStyles';

export const InlineErrorField = ({
  id,
  label,
  value,
  onChange,
  errorMessage,
  type = 'text',
  autoFocus = false,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string | null;
  type?: 'text' | 'password';
  autoFocus?: boolean;
}) => (
  <FormControl size='small' className='w-full'>
    <FormLabel htmlFor={id}>{label}</FormLabel>
    <TextField
      type={type}
      autoFocus={autoFocus}
      autoComplete={type === 'password' ? 'new-password' : undefined}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      error={!!errorMessage}
      sx={{
        ...inputSx,
        '& .MuiInputBase-root': {
          paddingRight: errorMessage ? '4px' : undefined,
        },
      }}
      slotProps={{
        htmlInput: { id, 'data-testid': id },
        input: {
          endAdornment: errorMessage ? (
            <InputErrorIcon errorMessage={errorMessage} />
          ) : undefined,
        },
      }}
    />
  </FormControl>
);
